/** @format */

import { useKey } from 'hooks';
import theme from 'theme/themes';
import { IThemeColor } from 'types';
import { KEY_CONTEXT } from 'utils';

export default () => {
  const { getKey } = useKey();
  const mode = getKey(KEY_CONTEXT.THEME_MODE) as IThemeColor;
  return {
    container: { minWidth: 200 },
    row: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    btn: { cursor: 'pointer' },
    bgWhite: { backgroundColor: 'white' },
    wrapOpAvContent: {
      py: 2,
      borderBottom: '2px solid  rgba(0, 0, 0, 0.55)',
    },
    flexCenter: {
      display: 'flex',
      justifyContent: 'center',
      mb: 2,
    },
    wrapOptAvatar: {
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.55)',
      borderRadius: '50%',
      width: 55,
      height: 55,
      cursor: 'pointer',
    },
    avatarBox: {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
    avatar: {
      width: '100%',
      height: '100%',
      backgroundColor: theme.palette.primary[mode],
    },
    cameraBox: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      p: '0.9em',
      backgroundColor: 'white',
      borderRadius: '50%',
      width: '1.5em',
      height: '1.5em',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.55)',
    },
    camera: {
      fontSize: 20,
      color: theme.palette.primary[mode],
    },
  };
};
